import React, { ReactNode } from "react"
import * as styles from "./ProductLeadDescription.module.scss"

export type ProductLeadDescriptionProps = {
  term: ReactNode
  children?: React.ReactNode
}

const ProductLeadDescription = (props: ProductLeadDescriptionProps) => {
  // console.log("Rendering ProductLeadDescription", props)

  if (!React.Children.count(props.children)) {
    return null
  }

  return (
    <div
      className={styles.container}
      itemProp="additionalProperty"
      itemScope
      itemType="https://schema.org/PropertyValue">
      <dt className={styles.term} itemProp="name">
        {props.term}
      </dt>
      {React.Children.map(props.children, child => {
        return (
          <dd className={styles.detail} itemProp="value">
            {child}
          </dd>
        )
      })}
    </div>
  )
}

export default ProductLeadDescription
